// @flow

import * as React from 'react';
import { connect } from 'react-redux';

import { CategoryListWrapper } from '../../containers';
import { Category } from '../../components';
import { servicesCategories } from '../../utils/variables';

import type { PlaceType, CategoryType } from '../../api/types';
import type { DefaultStateType } from '../../redux/reducers';

type Props = {
  currentPlace: PlaceType,
  categories: Array<CategoryType>,
};

const Content = (props: Props) => {
  const getFilteredCategories = () =>
    props.categories.filter(
      category =>
        servicesCategories.includes(category.name) && category.places.find(place => place.id === props.currentPlace.id),
    );

  const categoriesList = getFilteredCategories();

  return (
    <CategoryListWrapper>
      {categoriesList ? categoriesList.map(category => <Category key={category.id} category={category} />) : null}
    </CategoryListWrapper>
  );
};

const mapStateToProps = (state: DefaultStateType): { currentPlace: PlaceType, categories: Array<CategoryType> } => ({
  currentPlace: state.currentPlace,
  categories: state.categories,
});

export default connect(mapStateToProps)(Content);



// WEBPACK FOOTER //
// ./src/pages/Categories/Content.js